import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-footer" }
const _hoisted_2 = { class: "px-footer__container" }
const _hoisted_3 = { class: "px-footer__menu" }
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  alt: "VIRAL Logo",
  class: "px-footer__logo",
  src: "/img/logos/abaca-logo--dark.svg"
}, null, -1)
const _hoisted_6 = { class: "px-footer__copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.value,
            class: _normalizeClass([item.class, "px-footer-menu-item"]),
            href: item.value,
            target: _ctx.itemTarget(item)
          }, _toDisplayString(item.label), 11, _hoisted_4))
        }), 128))
      ]),
      _hoisted_5,
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("common.footer.copyright", {
            year: _ctx.currentYear,
          })), 1)
    ])
  ]))
}